<script setup lang="ts">
import type { Component, Page } from '@bloomreach/spa-sdk'
import { toRefs } from 'vue'
import chevronBreadcrumbsIcon from '@/assets/icons/blog/chevron_right_gray.svg'

const props = defineProps<{
    component: Component
    page: Page
}>()

/**
 * SDX
 */

const { component, page } = toRefs(props)
const data = component.value.getModels()

const { breadcrumbs } = data
const indexLastUrl = breadcrumbs.filter((el: { url: string }) => el.url).length - 1

const isSearchPage = JSON.stringify(page.value.toJSON()).includes('"searchform"')
</script>

<template>
    <section class="mx-auto mt-4 flex max-w-6.5xl gap-2 px-3 lg:mt-6 lg:px-0">
        <AtomImage
            v-if="isSearchPage"
            :src="chevronBreadcrumbsIcon"
            alt=""
            img-class="md:hidden rotate-180"
        />
        <a
            v-for="(item, idx) in breadcrumbs"
            :key="item.name"
            :href="item.url"
            class="c-items flex items-center gap-2 text-sm text-plush-gray-500"
            :class="[item.url ? 'font-medium' : 'hidden font-normal md:block']"
        >
            {{ item.name }}
            <AtomImage
                v-if="item.url"
                :src="chevronBreadcrumbsIcon"
                alt=""
                :img-class="[idx === indexLastUrl ? 'hidden md:block' : '']"
            />
        </a>
    </section>
</template>

<style lang="scss">
.c-items {
    align-items: last baseline;
}
</style>
